import type {z} from "zod";

import {CreateRepresentativeBody} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {representativeFieldLabelIds} from "../../../messages/representatives.messages";

const createCompany = CreateRepresentativeBody.shape.company;
const createProfile = createCompany.shape.partyProfile;
const createPhone = createProfile.shape.phone;
const createContract = CreateRepresentativeBody.shape.contract;

export const createRepresentativeAddressSchema = requiredStringSchema(
  createProfile.shape.address.shape.address,
  representativeFieldLabelIds.address,
);
export const createRepresentativeCompanyNameSchema = requiredStringSchema(
  createCompany.shape.companyName,
  representativeFieldLabelIds.companyName,
);
export const createRepresentativeCompanyIdSchema = requiredStringSchema(
  createCompany.shape.companyId,
  representativeFieldLabelIds.companyId,
);

export const createRepresentativeFormSchema = zod.object({
  companyId: createRepresentativeCompanyIdSchema,
  companyName: createRepresentativeCompanyNameSchema,
  address: createRepresentativeAddressSchema,
  country: createProfile.shape.country,
  phoneNumber: createPhone.shape.nationalNumber,
  phonePrefix: createPhone.shape.regionCode,
  websiteUrl: createProfile.shape.websiteUrl,
  logoUrl: CreateRepresentativeBody.shape.logoUrl,
  exclusive: CreateRepresentativeBody.shape.exclusive,
  contractedAt: createContract.shape.contractedAt,
  durationMonths: createContract.shape.durationMonths,
});
export type CreateRepresentativeFormPayload = z.output<typeof createRepresentativeFormSchema>;

export const draftCreateRepresentativeFormSchema = createRepresentativeFormSchema.partial();
export type DraftCreateRepresentativeFormPayload = z.output<
  typeof draftCreateRepresentativeFormSchema
>;
